module.exports = __webpack_public_path__ + "img/chivas-ferrari-mobile-img.cf07cc39.png";